module.exports = __webpack_public_path__ + "yellow.jpg?137bbe94183becaece1fe8079707d0a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendar-info/yellow.jpg
// module id = 489
// module chunks = 1